import React, { useState } from "react";
import { Badge, Button, Spinner } from "react-bootstrap";
import {
  faPlugCircleCheck,
  faTrashCan,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";

const PaypalAccountListItem = ({
  index,
  account,
  accountList,
  setAccountList,
  updatingAccount,
  setUpdatingAccount,
}) => {
  const [deleting, setDeleting] = useState(false);
  const [testing, setTesting] = useState(false);

  const handleDelete = async () => {
    if (!window.confirm("Xác nhận xoá tài khoản PayPal này?")) return;
    setDeleting(true);
    try {
      const data = await Utils._apiRequest({
        path: Enums.endpoints.paypal.ACCOUNT_PR,
        pathParams: { id: account._id },
        type: "DELETE",
      });
      if (data?._id) {
        setAccountList(accountList.filter((a) => a._id !== data._id));
        toast.success("Đã xoá tài khoản PayPal");
      } else if (data?.errors) {
        toast.error(data.errors.message || "Không thể xoá");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setDeleting(false);
    }
  };

  const handleTest = async () => {
    setTesting(true);
    try {
      const data = await Utils._apiRequest({
        path: Enums.endpoints.paypal.ACCOUNT_TEST,
        pathParams: { id: account._id },
        type: "POST",
      });
      if (data?.ok) toast.success("Kết nối PayPal thành công");
      else toast.error(data?.errors?.message || "Kết nối thất bại");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setTesting(false);
    }
  };

  const buildStatus = (status) => {
    switch (status) {
      case "pending":
        return <Badge bg="warning" text="dark">{status}</Badge>;
      case "suspended":
        return <Badge bg="danger">{status}</Badge>;
      case "unconnected":
        return <Badge bg="secondary">{status}</Badge>;
      default:
        return <Badge bg="success">{status}</Badge>;
    }
  };

  const buildMode = (mode) => (
    <Badge bg={mode === "sandbox" ? "info" : "primary"}>{mode || "live"}</Badge>
  );

  return (
    <tr
      className={`table-row${deleting ? " deleting" : ""}${
        updatingAccount && updatingAccount._id
          ? updatingAccount._id === account._id
            ? " updating"
            : " disabled"
          : ""
      }`}
    >
      <td>{index + 1}</td>
      <td>{account.accountName}</td>
      <td className="text-overflow">{account.account}</td>
      <td>{buildMode(account.meta?.mode)}</td>
      <td>{buildStatus(account.status)}</td>
      <td className="text-overflow">{account.meta?.email || "—"}</td>
      <td className="text-inline text-end">
        <Button
          className="ms-1"
          size="xs"
          variant="dark"
          onClick={() => setUpdatingAccount(account)}
          title="Sửa"
        >
          <FontAwesomeIcon icon={faWandMagicSparkles} />
        </Button>
        <Button
          className="ms-1"
          size="xs"
          variant="primary"
          onClick={handleTest}
          disabled={testing}
          title="Test kết nối"
        >
          {testing ? <Spinner size="sm" animation="border" /> : <FontAwesomeIcon icon={faPlugCircleCheck} />}
        </Button>
        <Button
          className="ms-1"
          size="xs"
          variant="danger"
          onClick={handleDelete}
          title="Xoá"
        >
          <FontAwesomeIcon icon={faTrashCan} />
        </Button>
      </td>
    </tr>
  );
};

export default PaypalAccountListItem;
